import { Typography, Link } from "@mui/material";

function Copyright(props) {
    return (
      <Typography variant="body2" color="text.secondary" align="center" {...props} paddingBottom={'20px'} paddingTop={'20px'}>
        {'Copyright © '}
        <Link color="inherit" href="https://hopbon.co.th/">
          HOPBON
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
    );
  }
export default Copyright;